import React, { useState, useRef } from 'react';
import ReactSVG from 'react-svg';
import cx from 'classnames';
import { withTranslation } from 'react-i18next';
import SmartPortal from '../SmartPortal';
import './styles.scss';

const GlobalFile = (props) => {

  const { fileId, fileName, fileSize, t, deleteFile, removable } = props;

  const [isFileDropdownOpen, setIsFileDropdownOpen] = useState(false);
  const elementRef = useRef(null);

  const toggleFileActionsDropdown = () => {
    setIsFileDropdownOpen(prevState => !prevState);
  };

  function formatFileSize(sizeInBytes) {
    if (sizeInBytes === 0) return '(0 B)';
    const units = ['B', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(sizeInBytes) / Math.log(1024));
    const size = sizeInBytes / Math.pow(1024, i);
    return `(${size.toFixed(1).replace('.', ',')} ${units[i]})`;
  }

  return (
    <div className="global-file">
      <a className="global-file-link" target="_blank" href={`../mw/file?fileId=${fileId}&download=0`} title={fileName}>
        <ReactSVG className="global-file-icon" src="/data/svg/comments_file.svg" />
        <div className="global-file-name">{fileName}</div>
        <div className="global-file-size">
          {fileSize != null ? formatFileSize(fileSize) : ''}
        </div>
      </a>
        <div className="global-file-actions">
          <button
            type="button"
            className={cx("global-file-dropdown-button", {"global-file-dropdown-button--open": isFileDropdownOpen})}
            onClick={toggleFileActionsDropdown}
            aria-haspopup="true"
            aria-expanded={isFileDropdownOpen}
            aria-label="File Actions"
            ref={elementRef}
          >
            <ReactSVG className="global-file-dropdown-icon" src="/data/svg/dropdown.svg" />
          </button>
          {isFileDropdownOpen && (
            <SmartPortal
              portalClassName="portal-global-file"
              targetElement={elementRef && elementRef.current}
              portalPlacement="bottom inner-right"
              portalKey={fileId}
              onClickOutside={() => setIsFileDropdownOpen(false)}
              outerOffset={4}
            >
            <div className="global-file-dropdown" role="menu">
              <a className="global-file-dropdown__option" target="_blank" href={`../mw/file?fileId=${fileId}&download=1`} onClick={toggleFileActionsDropdown}>
                {t('commentSection.download')}
              </a>
              <a className="global-file-dropdown__option" target="_blank" href={`../mw/file?fileId=${fileId}&download=0`} onClick={toggleFileActionsDropdown}>
                {t('commentSection.open')}
              </a>
              {removable && (
               <div className="global-file-dropdown__option" onClick={() => {
                    deleteFile(fileId);
                    setTimeout(() => setIsFileDropdownOpen(false), 250);
                  }
                }>
                 {t('commentSection.delete')}
               </div>
              )}
            </div>
          </SmartPortal>
          )}
        </div>
    </div>
  );
};

export default (withTranslation()(GlobalFile));
